<template lang="pug">
  label.controls-group.controls-group_v-centered.nav-group.input-check(v-bind:class="['input-check_'+type, {'is-disabled': isDisabled}]")
    input(
      :id="id"
      :name="name"
      :type="inputType"
      :disabled="isDisabled"
      :value="value"
      :checked="checked"
      @change="changeHandler($event)"
    )
    div.input-check__inp.nav-group__item
    span.nav-group__item(v-if="label") {{label}}
</template>

<script>
  // mixins
  import fieldProps from '@/mixins/fieldProps';
  import checkConditions from '@/mixins/questionConditions';

  export default {
    name: 'input-check',
    mixins: [fieldProps, checkConditions],
    props: {
      type: {
        type: String,
        default: 'box'
      },
      id: {
        type: Number,
        default: null
      },
      name: {
        type: String,
        default: null
      },
      label: {
        type: String,
        default: null
      },
      value: {
        type: String,
        default: null
      },
      stateChecked: {
        type: Boolean,
        default: false
      },
      isDisabled: {
        type: Boolean,
        default: false
      },
      event: {
        type: String,
        default: null
      }
    },
    computed: {
      inputType: function () {
        return this.$props.type === 'box' ? 'checkbox' : 'radio'
      },
      checked: {
        get: function () {
          return this.$props.stateChecked
        },
        set: function (checked) {
         return checked;
        }
      }
    },
    methods: {
      changeHandler: function (e) {
        const { checked } = e.target;

        const answer = {
          pollId: this.$props.pollId,
          question: this.$props.question,
          checked: checked
        };
        answer[this.$props.output_type] = checked;

        if (!this.$props.event) {
          this.$store.dispatch('answers/addRemoveAnswer', answer);
        } else {
          let answer = {
            id: this.$props.id,
            surveyId: this.$attrs.hasOwnProperty('survey') ? this.$attrs.survey.id : null, // survey - эта шляпа тольк в выборе тем опросов
            value: this.$props.value,
            checked: checked,
            name: this.$props.name
          };
          answer[this.$props.output_type] = checked;
          this.$parent.$emit(this.$props.event, answer);
        }

        // проверка условий
        if (this.$props.dependent) {
          this.$props.dependent.map(() => {
            if (this.inputType === 'checkbox') {
              this.$store.dispatch('conditions/changeConditionState', { name: this.$props.name, value: this.$props.value, checked: checked })
            }
          })
        }
      }
    }
  }
</script>

<style lang="scss" src="./assets/checkbox-radio.scss"></style>
